import React, { lazy, Suspense } from 'react';

const LazyApplicationLayout = lazy(() => import('./ApplicationLayout'));

const ApplicationLayout = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyApplicationLayout {...props} />
  </Suspense>
);

export default ApplicationLayout;
